import { createSlice } from '@reduxjs/toolkit';

export interface ShopifyReviewDialogState {
    isDisplayed: boolean;
}

const shopifyReviewDialog = createSlice({
    name: 'shopify-review-dialog',
    initialState: {
        isDisplayed: false,
    },
    reducers: {
        shopifyReviewDialogDisplayed: (state) => {
            state.isDisplayed = true;
        },
    },
});

export const { shopifyReviewDialogDisplayed } = shopifyReviewDialog.actions;

export default shopifyReviewDialog.reducer;
